import { ChevronDown, Grid3X3, Maximize2, MonitorPlay, MousePointer2, Move3D, RedoDot, Rotate3D, Scaling, Shield, ZoomIn, ZoomOut } from 'lucide-react';
import { useState } from 'react';
import { useEditorStore } from '../../store/editorStore';
import { IconButton } from '../ui/IconButton';

export function PreviewToolbar({ safeZones, setSafeZones, grid, setGrid }: { safeZones: boolean; setSafeZones(value: boolean): void; grid: boolean; setGrid(value: boolean): void }) {
  const workspace = useEditorStore((state) => state.workspace);
  const [zoom, setZoom] = useState('Fit');
  return <div className="preview-toolbar">
    <div className="preview-tool-group">
      <IconButton icon={<MousePointer2 size={15} />} label="Select tool (V)" active compact />
      <IconButton icon={<Move3D size={15} />} label="Move tool" compact />
      {workspace === '3d' && <><IconButton icon={<Rotate3D size={16} />} label="Rotate tool" compact /><IconButton icon={<Scaling size={15} />} label="Scale tool" compact /></>}
    </div>
    <div className="preview-title"><MonitorPlay size={13} /><span>{workspace === '3d' ? 'Realtime 3D composite' : 'Program monitor'}</span><span className="preview-quality">FULL</span></div>
    <div className="preview-tool-group right">
      <IconButton icon={<Grid3X3 size={15} />} label="Grid" active={grid} onClick={() => setGrid(!grid)} compact />
      <IconButton icon={<Shield size={15} />} label="Safe zones" active={safeZones} onClick={() => setSafeZones(!safeZones)} compact />
      <IconButton icon={<RedoDot size={15} />} label="Reset view" compact />
      <div className="zoom-select"><ZoomOut size={13} /><button onClick={() => setZoom(zoom === 'Fit' ? '50%' : 'Fit')}>{zoom}<ChevronDown size={11} /></button><ZoomIn size={13} /></div>
      <IconButton icon={<Maximize2 size={15} />} label="Fullscreen canvas (F11)" onClick={() => document.querySelector('.preview-panel')?.requestFullscreen()} compact />
    </div>
  </div>;
}
